import { render, staticRenderFns } from "./internetIndusry.vue?vue&type=template&id=7f52bb8a"
import script from "./internetIndusry.vue?vue&type=script&lang=js"
export * from "./internetIndusry.vue?vue&type=script&lang=js"
import style0 from "./internetIndusry.vue?vue&type=style&index=0&id=7f52bb8a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports